export default "__VITE_ASSET__Bivbekfv__"